import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';



@Injectable()
export class ServicioProvider {

  private readonly sessionStorageKey = 'snappc-reportes-session-v1';

  dominio = APP_CONFIG.apiBaseUrl;
  licencia = APP_CONFIG.license;

  tipo_reporte = "";
  name_reporte = "";
  save_apikey = "";
  nombre_cliente = "";

  array_save_fecha: any = [];
  array_locaciones: any = [];
  array_datos_locacion: any = [];
  nombre_reposte: any = [];

  constructor(public http: HttpClient) { this.restoreSession(); }

  /////////////////  Locaciones  //////////////////////////////////////////
  save_locaciones(array) {
    this.array_locaciones = array;
    this.persistSession();
  }
  ver_locaciones() {
    return this.array_locaciones;
  }
  cambiar_Locacion(array) {
    this.array_datos_locacion = array;
    this.persistSession();
  }
  elegir_locacion() {
    return this.array_datos_locacion;
  }
  /////////////////////////////////////////////////////////////////////////
  save_nombre_reportes(data) {
    this.nombre_reposte = data;
  }
  ver_nombre_reportes() {
    this.nombre_reposte;;
  }

  save_apikey_login(dato) {
    this.save_apikey = dato;
    this.persistSession();
  }
  ver_apikey_login() {
    return this.save_apikey;
  }
  clear_apikey_login() {
    this.save_apikey = "";
    this.persistSession();
  }
  clear_session() {
    this.tipo_reporte = "";
    this.name_reporte = "";
    this.save_apikey = "";
    this.nombre_cliente = "";
    this.array_save_fecha = [];
    this.array_locaciones = [];
    this.array_datos_locacion = [];
    this.nombre_reposte = [];
    this.removePersistedSession();
  }

  hasActiveSession(): boolean {
    return typeof this.save_apikey === 'string' && this.save_apikey.length > 0;
  }

  private persistSession(): void {
    const storage = this.sessionStorage();
    if (!storage) { return; }
    if (!this.save_apikey) {
      this.removePersistedSession();
      return;
    }
    try {
      storage.setItem(this.sessionStorageKey, JSON.stringify({
        apiKey: this.save_apikey,
        locations: this.array_locaciones,
        selectedLocation: this.array_datos_locacion
      }));
    } catch (_) {}
  }

  private restoreSession(): void {
    const storage = this.sessionStorage();
    if (!storage) { return; }
    try {
      const value = JSON.parse(storage.getItem(this.sessionStorageKey) || 'null');
      if (!value || typeof value.apiKey !== 'string' || !value.apiKey || !Array.isArray(value.locations)) { return; }
      this.save_apikey = value.apiKey;
      this.array_locaciones = value.locations;
      this.array_datos_locacion = value.selectedLocation && value.selectedLocation.idlocacion !== undefined
        ? value.selectedLocation : (value.locations[0] || null);
    } catch (_) { this.removePersistedSession(); }
  }

  private removePersistedSession(): void {
    const storage = this.sessionStorage();
    if (!storage) { return; }
    try { storage.removeItem(this.sessionStorageKey); } catch (_) {}
  }

  private sessionStorage(): Storage | null {
    try { return typeof window !== 'undefined' ? window.sessionStorage : null; } catch (_) { return null; }
  }
  guardar_nombre_cliente(dato) {
    this.nombre_cliente = dato;
  }
  ver_nombre_cliente() {
    return this.nombre_cliente;
  }
  save_ver_reporte(pos) {
    this.tipo_reporte = pos;
  }
  ver_reporte() {
    return this.tipo_reporte;
  }
  save_name_reporte(name) {
    this.name_reporte = name;
  }
  ver_name_reporte() {
    return this.name_reporte;
  }
  save_fecha(array) {
    this.array_save_fecha = array;
  }
  ver_fecha() {
    return this.array_save_fecha;
  }


  ///////////////////////////////////////////////////////////////////////////////
  get_ver_fotos(user, clave) {
    let json = "licencia=" + this.licencia + "&usuario=" + user + "&clave=" + clave;

    return new Promise(resolve => {
      this.http.post(this.dominio + "pedidos/consultar-pedido-supervisor", json, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      })
        .subscribe(res => {
          //console.log(JSON.stringify(res));
          var array_temp_dos;
          if (res['code'] == 0) {

            array_temp_dos = res['data'];

            if (array_temp_dos.length <= 0) {
              resolve(0);
            }
            else {
              resolve(array_temp_dos);
            }
          }
          else {
            resolve(0);
          }
        }, (err) => {
          resolve(0);
        });
    });
  }



  //////////////////////////////////////////////////////////////////////////////////////////
  async mostrar_reporte(json) {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
    let url = this.dominio + 'reportes/reporte';
    let respuesta: any;

    try {
      respuesta = await this.http.post(url, json, options).toPromise().then();

      if (respuesta['code'] == 0) {
        ////console.log(respuesta);
        return respuesta;
      }
      else {
        return "1";
      }

    } catch (err) {
      return "error";
    }
  }


  //////////////////////////////////////////////////////////////////////////////////

  buscar_pedido(json_mandar) {// metodo para cancelar un pedido

    return new Promise(resolve => {
      this.http.post(this.dominio + 'pedidos/buscar-pedido', json_mandar, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      })
        .subscribe(datos => {
          // //console.log(JSON.stringify(datos));

          if (datos['code'] == 0) {
            resolve(datos['pedidos']);
          }
          else {
            resolve(0);
          }

        }, (err) => {

          //console.log("error hoy\n" + JSON.stringify(err));
        });
    });
  }


  //////////////////////////////////////////////////////////////////////////////////

  get_ver_pedidos(json_mandar) { // metodo para obtener los pedidos 
    return new Promise(resolve => {
      this.http.post(this.dominio + 'pedidos/lista-pedidos', json_mandar, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      })
        .subscribe(res => {

          //console.log(JSON.stringify(res));
          var array_temp = [];

          if (res['code'] == 0) {
            array_temp = res['pedidos'];

            if (array_temp.length <= 0) {
              resolve(0);
            }
            else {
              resolve(array_temp);
            }

          }
          else {
            resolve(0);
          }

        }, (err) => {

          //console.log("error hoy\n" + JSON.stringify(err));
        });
    });
  }

  //////////////////////////////////////////////////////////////////////////////////

  autorizacion(json_mandar) {


    return new Promise(resolve => {
      this.http.post(this.dominio + "usuarios/autorizar", json_mandar, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      })
        .subscribe(datos => {
          // //console.log(JSON.stringify(datos));
          var array = [];

          if (datos['code'] == 0) {

            array = datos['data'];
            let dat = array[0].apikey;
            ////console.log(array[0].apikey);
            resolve(dat);
          }
          else {
            resolve(0);
          }

        }, (err) => {
          resolve(-1);
        });
    });
  }


  //////////////////////////////////// reportes //////////////////////////////////
  lista_reportes(json) {
    return new Promise(resolve => {
      this.http.post(this.dominio + 'catalogo/reportes', json, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      })
        .subscribe(datos => {
          if (datos['code'] == 0) {
            resolve(datos['reportes']);
          }
          else {
            resolve(0);
          }

        }, (err) => {

          //console.log("error hoy\n" + JSON.stringify(err));
        });
    });
  }

  tiene_acceso_modulo(idmodulo: number): Promise<boolean> {
    const apikey = this.ver_apikey_login();
    if (!apikey || !idmodulo) {
      return Promise.resolve(false);
    }

    const json = 'apikey=' + encodeURIComponent(apikey) + '&idmodulo=' + idmodulo;
    return new Promise(resolve => {
      this.http.post(this.dominio + 'catalogo/acceso', json, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      }).subscribe(datos => resolve(datos['code'] == 0), () => resolve(false));
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  cancelar_pedido(json_mandar) {// metodo para cancelar un pedido

    return new Promise(resolve => {
      this.http.post(this.dominio + 'pedidos/bloquear-pedido', json_mandar, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      })
        .subscribe(datos => {
          ////console.log(JSON.stringify(datos));

          if (datos['code'] == 0) {
            resolve(1);
          }
          else {
            resolve(0);
          }

        }, (err) => {

          //console.log("error hoy\n" + JSON.stringify(err));
        });
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  reactivar_pedido(json_mandar) {// metodo para cancelar un pedido

    return new Promise(resolve => {
      this.http.post(this.dominio + 'pedidos/desbloquear-pedido', json_mandar, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        })
      })
        .subscribe(datos => {
          ////console.log(JSON.stringify(datos));

          if (datos['code'] == 0) {
            resolve(1);
          }
          else {
            resolve(0);
          }

        }, (err) => {

          //console.log("error hoy\n" + JSON.stringify(err));
        });
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////

}



// WEBPACK FOOTER //
// ./src/providers/servicio/servicio.ts